<template>
  <div class="statistics-content">
    <div class="statistics-grid">
      <div class="stat-row">
        <div class="stat-item">
          <div class="stat-value">{{ formatNumber(statistics.total_games) }} / {{ formatNumber(statistics.total_questions) }}</div>
          <div class="stat-label">
            <i class="el-icon-trophy" style="margin-right: 4px; color: #409EFF; font-size: 15px;"></i>
            场次/题数
          </div>
        </div>
        <div class="stat-item">
          <div class="stat-value">{{ formatPercentage(statistics.score_rate) }}</div>
          <div class="stat-label">
            <i class="el-icon-data-line" style="margin-right: 4px; color: #67C23A; font-size: 15px;"></i>
            得分率
          </div>
        </div>
        <div class="stat-item">
          <div class="stat-value">Top {{ formatPercentage(statistics.rank_rate) }}</div>
          <div class="stat-label">
            <i class="el-icon-sort" style="margin-right: 4px; color: #E6A23C; font-size: 15px;"></i>
            排位
          </div>
        </div>
        <!-- 新增平均难度统计项 -->
        <div class="stat-item">
          <div class="stat-value difficulty-value">
            <template v-if="statistics.avg_difficulty !== null && statistics.avg_difficulty !== undefined">
              <span :style="{ color: getDifficultyTextColor(statistics.avg_difficulty) }">
                <span 
                  class="difficulty-color-block" 
                  :style="{ backgroundColor: getDifficultyBlockColor(statistics.avg_difficulty) }">
                </span>
                {{ formatDifficultyPercentage(statistics.avg_difficulty) }}
              </span>
            </template>
            <template v-else>未定义</template>
          </div>
          <div class="stat-label">
            <i class="el-icon-finished" style="margin-right: 4px; color: #8E44AD; font-size: 15px;"></i>
            平均难度
          </div>
        </div>
        <div class="stat-item">
          <div class="stat-value unfix-value">{{ formatNumber(statistics.unfix_count) }}</div>
          <div class="stat-label">
            <i class="el-icon-bell" style="margin-right: 4px; color: #F56C6C; font-size: 15px;"></i>
            未订正
          </div>
        </div>
        <div class="stat-item">
          <div class="stat-value pending-value">{{ formatNumber(statistics.pending_count) }}</div>
          <div class="stat-label">
            <i class="el-icon-video-pause" style="margin-right: 4px; color: #E6A23C; font-size: 15px;"></i>
            挂起
          </div>
        </div>
        <div class="stat-item">
          <div class="stat-value">{{ formatPercentage(statistics.ac_rate) }}</div>
          <div class="stat-label">
            <i class="el-icon-circle-check" style="margin-right: 4px; color: #409EFF; font-size: 15px;"></i>
            AC率
          </div>
        </div>
        <div class="stat-item">
          <div class="stat-value">{{ formatPercentage(statistics.fix_rate) }}</div>
          <div class="stat-label">
            <i class="el-icon-notebook-2" style="margin-right: 4px; color: #67C23A; font-size: 15px;"></i>
            订正率
          </div>
        </div>
        <div class="stat-item">
          <div class="stat-value">{{ formatPercentage(statistics.master_rate) }}</div>
          <div class="stat-label">
            <i class="el-icon-magic-stick" style="margin-right: 4px; color: #E6A23C; font-size: 15px;"></i>
            掌握率
          </div>
        </div>
        <div class="stat-item">
          <div class="stat-value">{{ formatPercentage(statistics.replay_rate) }}</div>
          <div class="stat-label">
            <i class="el-icon-video-camera" style="margin-right: 4px; color: #546E7A; font-size: 15px;"></i>
            复盘率
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getGameStatistics } from '@/api/game'
import request from '@/utils/request'

export default {
  name: 'GameStatistics',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    filterParams: {
      type: Object,
      default: () => ({
        game_name: '',
        game_type: '',
        game_level: '',
        fix_status: '',
        replay_status: '',
        game_time_start: '',
        game_time_end: ''
      })
    }
  },
  data() {
    return {
      statistics: {
        total_games: 0,
        total_questions: 0,
        ac_rate: 0,
        fix_rate: 0,
        master_rate: 0,
        replay_rate: 0,
        unfix_count: 0,
        pending_count: 0,
        rank_rate: 0,
        score_rate: 0,
        avg_difficulty: 0 // 新增平均难度字段
      },
      refreshInterval: null
    }
  },
  created() {
    this.fetchStatistics()
    this.startAutoRefresh()
  },
  beforeDestroy() {
    this.stopAutoRefresh()
  },
  methods: {
    async fetchStatistics() {
      try {
        console.log('[Statistics] Fetching statistics with params:', this.filterParams);
        
        // 处理请求参数，确保数组类型正确
        const params = {};
        
        // 处理字符串类型参数
        params.game_name = this.filterParams.game_name || '';
        params.game_type = this.filterParams.game_type || '';
        params.game_level = this.filterParams.game_level || '';
        params.fix_status = this.filterParams.fix_status || '';
        params.replay_status = this.filterParams.replay_status || '';
        params.game_time_start = this.filterParams.game_time_start || '';
        params.game_time_end = this.filterParams.game_time_end || '';
        
        console.log('[Statistics] Processed params:', params);
        
        // 获取基本统计数据
        const response = await getGameStatistics(params);
        
        if (response.code === 200) {
          this.statistics = {
            ...this.statistics,
            ...response.data
          };
          
          // 确保题目总数字段存在，如果后端没有返回，则使用默认值
          if (this.statistics.total_questions === undefined || this.statistics.total_questions === null) {
            this.statistics.total_questions = 0;
          }

          // 确保平均难度字段存在，如果后端没有返回，则使用默认值
          if (this.statistics.avg_difficulty === undefined || this.statistics.avg_difficulty === null) {
            this.statistics.avg_difficulty = 0;
          }
          
          console.log('[Statistics] Updated statistics:', this.statistics);
        }
      } catch (error) {
        console.error('[Statistics] Error fetching statistics:', error);
        this.$message.error('获取统计数据失败');
      }
    },
    
    formatNumber(value) {
      return value || 0
    },

    formatPercentage(value) {
      return value ? value.toFixed(2) + '%' : '0.00%'
    },

    formatDifficultyPercentage(value) {
      return value ? value.toFixed(2) + '%' : '0.00%';
    },

    getDifficultyTextColor(value) {
      if (value === null || value === undefined) {
        return '#909399'; // 默认灰色
      }
      if (value < 14.29) return '#6D5B44'; // 与第一个卡片深色相同
      if (value < 28.58) return '#754B3A'; // 与第二个卡片深色相同
      if (value < 42.87) return '#3B5135'; // 与第三个卡片深色相同
      if (value < 57.15) return '#4B3853'; // 与第四个卡片深色相同
      if (value < 71.44) return '#2A3F58'; // 与第五个卡片深色相同
      if (value < 85.72) return '#6B5427'; // 与第六个卡片深色相同
      return '#5A4B1D'; // 与第九个卡片深色相同
    },
    
    getDifficultyBlockColor(value) {
      if (value === null || value === undefined) {
        return '#909399'; // 默认灰色
      }
      if (value < 14.29) return '#F56C6C'; // 红题
      if (value < 28.58) return '#E6A23C'; // 橙题
      if (value < 42.87) return '#F7BA2A'; // 黄题
      if (value < 57.15) return '#67C23A'; // 绿题
      if (value < 71.44) return '#409EFF'; // 蓝题
      if (value < 85.72) return '#8E44AD'; // 紫题
      return '#2C3E50'; // 黑题
    },

    getDifficultyPrefix(value) {
      if (value === null || value === undefined) {
        return '未知.';
      }
      if (value < 14.29) return '红.';
      if (value < 28.58) return '橙.';
      if (value < 42.87) return '黄.';
      if (value < 57.15) return '绿.';
      if (value < 71.44) return '蓝.';
      if (value < 85.72) return '紫.';
      return '黑.';
    },
    
    startAutoRefresh() {
      if (this.refreshInterval) {
        clearInterval(this.refreshInterval)
      }
      this.refreshInterval = setInterval(() => {
        console.log('Auto refresh triggered')
        this.fetchStatistics()
      }, 60000)
    },
    
    stopAutoRefresh() {
      if (this.refreshInterval) {
        console.log('Stopping auto refresh')
        clearInterval(this.refreshInterval)
        this.refreshInterval = null
      }
    },
    
    refresh() {
      return this.fetchStatistics()
    }
  },
  watch: {
    loading: {
      immediate: true,
      handler(newValue) {
        if (!newValue) {
          this.fetchStatistics()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.statistics-content {
  padding: 0;
  height: 100%;
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  
  .statistics-grid {
    width: 100%;
    height: 70%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
    
    .stat-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 5px;
      height: calc(100% - 8px);
      width: 100%;
      
      .stat-item {
        flex: 1 1 0;
        height: 100%;
        padding: 12px 8px;
        border-radius: 8px;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        position: relative;
        overflow: hidden;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
        
        &:nth-child(1) {
          background: linear-gradient(to top, 
            rgba(226, 206, 186, 0.3) 0%, 
            rgba(226, 206, 186, 1) 100%);
          .stat-label, i { color: #8D7B64; }
          .stat-value { color: #6D5B44; }
        }
        &:nth-child(2) {
          background: linear-gradient(to top, 
            rgba(209, 178, 164, 0.3) 0%, 
            rgba(209, 178, 164, 1) 100%);
          .stat-label, i { color: #956B5A; }
          .stat-value { color: #754B3A; }
        }
        &:nth-child(3) {
          background: linear-gradient(to top, 
            rgba(190, 206, 185, 0.3) 0%, 
            rgba(190, 206, 185, 1) 100%);
          .stat-label, i { color: #5B7155; }
          .stat-value { color: #3B5135; }
        }
        &:nth-child(4) {
          background: linear-gradient(to top, 
            rgba(199, 188, 205, 0.3) 0%, 
            rgba(199, 188, 205, 1) 100%);
          .stat-label, i { color: #6B5873; }
          .stat-value { color: #4B3853; }
        }
        &:nth-child(5) {
          background: linear-gradient(to top, 
            rgba(187, 199, 214, 0.3) 0%, 
            rgba(187, 199, 214, 1) 100%);
          .stat-label, i { color: #4A5F78; }
          .stat-value { color: #2A3F58; }
        }
        &:nth-child(6) {
          background: linear-gradient(to top, 
            rgba(220, 198, 170, 0.3) 0%, 
            rgba(220, 198, 170, 1) 100%);
          .stat-label, i { color: #8B7447; }
          .stat-value { color: #6B5427; }
        }
        &:nth-child(7) {
          background: linear-gradient(to top, 
            rgba(215, 185, 185, 0.3) 0%, 
            rgba(215, 185, 185, 1) 100%);
          .stat-label, i { color: #8E5D5D; }
          .stat-value { color: #6E3D3D; }
        }
        &:nth-child(8) {
          background: linear-gradient(to top, 
            rgba(176, 200, 197, 0.3) 0%, 
            rgba(176, 200, 197, 1) 100%);
          .stat-label, i { color: #4A6764; }
          .stat-value { color: #2A4744; }
        }
        &:nth-child(9) {
          background: linear-gradient(to top, 
            rgba(195, 182, 154, 0.3) 0%, 
            rgba(195, 182, 154, 1) 100%);
          .stat-label, i { color: #7A6B3D; }
          .stat-value { color: #5A4B1D; }
        }
        &:nth-child(10) { // 复盘率
          background: linear-gradient(to top, 
            rgba(180, 195, 203, 0.3) 0%, 
            rgba(180, 195, 203, 1) 100%);
          .stat-label, i { color: #546E7A; }
          .stat-value { color: #37474F; }
        }
        
        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
          
          .stat-value {
            transform: scale(1.02);
          }
        }
        
        .stat-value {
          font-size: 20px;
          font-weight: 600;
          text-align: center;
          transition: transform 0.3s ease;
          white-space: nowrap;
          line-height: 40px;
          margin-bottom: 9px;
        }

        .difficulty-value {
          font-size: 20px;
          font-weight: 600;
          text-align: center;
          transition: transform 0.3s ease;
          white-space: nowrap;
          line-height: 40px;
          margin-bottom: 9px;
        }
        
        .stat-label {
          font-size: 12px;
          font-weight: 500;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 4px;
          height: 16px;
          line-height: 16px;
          white-space: nowrap;
          
          i {
            font-size: 14px;
            height: 24px;
            width: 24px;
            line-height: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            transition: all 0.3s ease;
            margin-right: 4px;

            &.el-icon-trophy {
              background-color: rgba(141, 123, 100, 0.1);
            }
            &.el-icon-data-line {
              background-color: rgba(149, 107, 90, 0.1);
            }
            &.el-icon-sort {
              background-color: rgba(91, 113, 85, 0.1);
            }
            &.el-icon-bell {
              background-color: rgba(107, 88, 115, 0.1);
            }
            &.el-icon-circle-check {
              background-color: rgba(74, 95, 120, 0.1);
            }
            &.el-icon-notebook-2 {
              background-color: rgba(139, 116, 71, 0.1);
            }
            &.el-icon-magic-stick {
              background-color: rgba(142, 93, 93, 0.1);
            }
            &.el-icon-video-camera {
              background-color: rgba(84, 110, 122, 0.1);
            }
            &.el-icon-video-pause {
              background-color: rgba(142, 93, 93, 0.1);
            }
            &.el-icon-star-on {
              background-color: rgba(142, 68, 173, 0.1);
            }
            &.el-icon-finished {
              background-color: rgba(142, 68, 173, 0.1);
            }
          }
        }
      }
    }
  }

  .difficulty-color-block {
    display: inline-block;
    width: 16px;
    height: 16px;
    border-radius: 3px;
    margin-right: 1px;
    vertical-align: -1px;
  }
}
</style> 